"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const styles_1 = require("../common/styles");
const ActionButtons_1 = __importDefault(require("../common/ActionButtons"));
const CloseIconButton_1 = __importDefault(require("../common/CloseIconButton"));
const StyledPopover = (0, styled_components_1.default)(Popover_1.default) `
  .MuiPaper-rounded {
    max-width: ${(props) => `${props.$maxWidth}px`};
    overflow-y: hidden;
  }
`;
const StyledPopoverContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  max-height: inherit;
`;
const ContentContainer = styled_components_1.default.div `
  padding: 24px;
`;
const StyledFooter = (0, styled_components_1.default)(ContentContainer) `
  display: flex;
  justify-content: space-between;
`;
const TitleContainer = (0, styled_components_1.default)(ContentContainer) `
  padding-bottom: 0;

  div {
    + div {
      margin-top: 16px;
    }
  }
`;
const ChildrenContainer = (0, styled_components_1.default)(ContentContainer) `
  flex-grow: 1;
  overflow-y: auto;
`;
const StyledSubTitle = (0, styled_components_1.default)(styles_1.SubTitle) `
  margin-top: 0;
  color: ${({ theme }) => theme.palette.gray[70]};
`;
const Popover = ({ actions, children, hideCloseIcon, onClose, maxWidth, title, subTitle, ...rest }) => {
    return ((0, jsx_runtime_1.jsxs)(StyledPopover, { "$maxWidth": maxWidth, "data-testid": "buoy-popover", onClose: onClose, ...rest, children: [!hideCloseIcon && ((0, jsx_runtime_1.jsx)(styles_1.CloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(CloseIconButton_1.default, { onClose: onClose }) })), (0, jsx_runtime_1.jsxs)(StyledPopoverContainer, { children: [(title || subTitle) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(TitleContainer, { children: [title && (0, jsx_runtime_1.jsx)(styles_1.StyledTitle, { children: title }), subTitle && (0, jsx_runtime_1.jsx)(StyledSubTitle, { children: subTitle })] }), (0, jsx_runtime_1.jsx)(styles_1.StyledDivider, {})] })), (0, jsx_runtime_1.jsx)(ChildrenContainer, { children: children }), actions && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(StyledFooter, { children: (0, jsx_runtime_1.jsx)(ActionButtons_1.default, { actions: actions }) })] }))] })] }));
};
exports.default = Popover;
//# sourceMappingURL=index.js.map